import { render, staticRenderFns } from "./Transplan.vue?vue&type=template&id=9ccc2f44"
import script from "./Transplan.vue?vue&type=script&lang=js"
export * from "./Transplan.vue?vue&type=script&lang=js"
import style0 from "./Transplan.vue?vue&type=style&index=0&id=9ccc2f44&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports